import { FC, useEffect, useState } from "react";
import image from "../../../assets/images/contaCriada.png";
import "./success.css";
import { useNavigate, useParams } from "react-router-dom";
import { useAppConfig } from "../../../hooks/useAppConfig";
import { Loading } from "../../../components/Loading";

const SuccessPage: FC = () => {
  const { pluginspace_id } = useParams();
  const navigate = useNavigate();
  const { getAppConfig } = useAppConfig();

  const [loading, setLoading] = useState(true);
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  const loadData = async () => {
    setLoading(true);
    try {
      const configData = await getAppConfig();
      if (configData?.webappcolor?.webappbutton) {
        setPrimaryColor(configData.webappcolor.webappbutton);
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <>
      {loading ? (
        <div className="loading-container">
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="success-main">
          <div className="success-image">
            <img src={image} alt="Conta Criada com Sucesso" />
          </div>

          <div className="success-header">
            <h1>Tudo pronto!</h1>
            <span>
              Sua conta foi criada com sucesso e já está pronta para uso.
            </span>
          </div>

          {/* Botão de Ação Direto para Login */}
          <div className="button-wrapper" style={{ marginTop: "2rem" }}>
            <button
              className="btn-login"
              style={{
                background: primaryColor,
                width: "100%",
                height: "3.2rem",
                borderRadius: "10px",
                color: "#FFF",
                border: "none",
                fontWeight: "700",
                fontSize: "1rem",
                cursor: "pointer",
              }}
              onClick={() => navigate(`/${pluginspace_id}/auth`)}
            >
              Ir para o Login
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export { SuccessPage };
